export default __webpack_public_path__ + "static/media/feature-2.07e8dcf8.svg";